import React from 'react';
import {
  Row, Col, Table, Badge, Button, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, Modal, ModalHeader, ModalBody, Card,
  CardHeader, CardBody, FormGroup,Input, NavItem,Nav
} from "reactstrap";
import { uuidv4 } from 'components/Notebook/operations/notebook';
import moment from 'moment'
import FileJobsService from '../../services/api/FileJobs';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import { Scrollbars } from 'react-custom-scrollbars';
import StorageService from '../../services/api/Storage';
import { convertTextToTitleCase } from "settings/shared/commonMethod";


class Versioning extends React.Component {
  constructor(props) {
    super(props)
    this.id = 'hot';
    this.hotTableComponent = React.createRef();
    this.state = {
      myContent: '',
      storageName: "",
      platformDefault: false,
      errorFile: "",
      hideCode: "",
      contextMenuTable: false,
      versionValue: props,
      listversion: props,
      fileName: props,
      storageId: props,
      rootFolder: props,
      selectedVersionName: '',
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      listversioning: [],
      showVersionInfo: false,
      currentVersion: '',
      currentComments: '',
      currentcreatedBy: '',
      showOriginal:false,
      versionName:'',
      showSaveModal: false,
      savecomments: '',
      showSavebutton: false,
      restoredby:"",
      restoredat: ""
    }
  }
  componentDidMount() {
    this.showVersioningList()
  }

  showVersioningList = () => {
    let prefix = this.state.listversion.fileName + '/';
    let pageToken = null;
    StorageService.listVersionObjects(prefix, null, this.state.listversion.storageId, this.state.listversion.rootFolder, pageToken)
      .then((response) => {
        this.setState({ listversioning: response.result });
      }).catch((error) => {
      })
  }
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  restoreVersionConfirmation = (versionName) => {
    this.setState({versionName:versionName})
    confirmAlert({
      title: 'Restore File',
      message: 'Are you sure to restore this file -' + this.state.fileName.fileName + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.toggleSaveModal()
        },
        {
          label: 'No',
          onClick: () => {
          }
        }
      ]
    });
  }
  saveCommentschange = (event) => {
    if (event !== null) {
      this.setState({ savecomments: event.target.value });
      if (this.state.savecomments !== null && this.state.savecomments.length > 3 && this.state.savecomments.length < 100) {
        this.setState({ showSavebutton: true })
      }
      else {
        this.setState({ showSavebutton: false })
      }
    }
  }
  toggleSaveModal = () => {
    this.setState({
      showSaveModal: !this.state.showSaveModal,
      savecomments:'',
    })
  }
  restoreVersion = (versioncomments) => {
    let currentUser = JSON.parse(localStorage.getItem("UserProfile"))
    let apitoken = currentUser.apiToken;
    let storageId = this.state.storageId.storageId
    let rootFolder = this.state.rootFolder.rootFolder
    let restorefiledata = {
      "filePath": this.state.fileName.fileName,
      "versionName": this.state.versionName,
      "restoreInfo": {
      "comment":versioncomments
      }
    }
    let sourceStorage = {}
    if (storageId !== null && storageId !== undefined && storageId !== "") {
      sourceStorage.storageId = storageId
    }

    if (rootFolder !== null && rootFolder !== undefined && rootFolder !== "") {
      sourceStorage.rootFolder = rootFolder
    }

    if (Object.keys(sourceStorage).length > 0) {
      sourceStorage.apiKey = apitoken
      restorefiledata.sourceStorage = sourceStorage
    }

    FileJobsService.restoreVersionObjects(restorefiledata)
      .then((response) => {
        if (response.status === "SUCCESS") {
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Restored Successfully!</b></i>);
          this.setState({showSaveModal:false})
        }
      });
  }
  selectedVersion = (filename) => {
    this.setState({ selectedVersionName: filename, showOriginal: false })
  }
  toggleVersionInfo = (version, createdby, comments, restoredat, restoredby) => {
    this.setState({
      showVersionInfo: !this.state.showVersionInfo,
      currentVersion: version,
      currentcreatedBy: createdby,
      currentComments: comments,
      restoredat: restoredat,
      restoredby:restoredby

    })
  }
  render() {
    return (
      <div>
        <Scrollbars autoHeight autoHeightMin={this.state.sheight - 280} thumbMinSize={30} >
        
        {this.state.listversioning !== null && this.state.listversioning !== undefined && this.state.listversioning.map((item, index) => (      
                 convertTextToTitleCase(item.file_name) === "Original" && <ul className="list-group">
                <li className={this.state.selectedVersionName === "original" ? "list-group-item active" : "list-group-item"}>
                <span className="text-primary"><b><i className="fas fa-caret-right"></i> &nbsp;Original</b></span>
                </li>
                <li className="list-group-item"> 
                    <Row className="original-hover">
                    <Col className="project-col version-text" xs="12" onClick={e => { this.props.update(this.state.fileName.fileName, this.state.storageId.storageId, this.state.rootFolder.rootFolder, item.file_name, item.metadata.comments); this.selectedVersion(item.file_name) }}>
                      <b>&nbsp;{(item.file_name !== null && convertTextToTitleCase(item.file_name) === "Original") ? moment.utc(item.created).local().format('MMM DD YYYY', 'h:mm:ss a') : ""}
                       &nbsp; {item.file_name !== null && convertTextToTitleCase(item.file_name) === "Original" ? moment.utc(item.created).local().format('h:mm A') : ""}  </b>
                    </Col>
                    </Row> 
                    <Row>     
                      <Col className="project-col" xs="11">
                        <Badge color="" className="badge-dot">
                          <i className={this.state.selectedVersionName === item.file_name ? "bg-success" : "bg-darkgray"} />
                         {item.metadata.hasOwnProperty('created_by') ? item.metadata.created_by : "" }
                        </Badge>
                      </Col>  
                    </Row>  
                </li>   
  
            </ul>
            )) 
         }
<ul className="list-group">
  <li className="list-group-item view-version-list">
  <span className="text-primary"><b><i className="fas fa-caret-right"></i> &nbsp;Version List</b></span>
  </li>
  {this.state.listversioning !== null && this.state.listversioning !== undefined && this.state.listversioning.map((item, index) => (      
               convertTextToTitleCase(item.file_name) !== "Original" &&
               <li className={this.state.selectedVersionName === item.file_name ? "list-group-item active" : "list-group-item borderless"} key={uuidv4()}>
                    <Row className="version-hover">
                      <Col className="project-col version-text" xs="10" onClick={e => { this.props.update(this.state.fileName.fileName, this.state.storageId.storageId, this.state.rootFolder.rootFolder, item.file_name, item.metadata.comments); this.selectedVersion(item.file_name) }}>
                        <b>{(item.file_name !== null && convertTextToTitleCase(item.file_name) !== "Original")? moment.utc(item.file_name).local().format('MMM DD YYYY', 'h:mm:ss a') : ""}
                         &nbsp;{item.file_name !== null && convertTextToTitleCase(item.file_name) !== "Original" ? moment.utc(item.file_name).local().format('h:mm A') : ""}  </b>
                      </Col>
                      <Col className="project-col version-text" xs="1" onClick={e => { this.toggleVersionInfo(item.file_name, item.metadata.created_by, item.metadata.comments, item.metadata.restore_at, item.metadata.restore_by) }}><i className="fas fa-info-circle"></i> &nbsp;</Col>
                      <Col className="project-col version-text" xs="1">
                      <UncontrolledDropdown direction="down">
                          <DropdownToggle
                            tag="span"
                            onClick={e => e.preventDefault()}
                            className="ellipsisicon"
                          >
                          <i className="fas fa-ellipsis-v pl-1" />
                          </DropdownToggle>
                          <DropdownMenu
                            persist right
                            className="dropdown-menu-arrow"
                          >

                            <DropdownItem
                              href=""
                              className={this.state.disabledclone}
                              onClick={e => {
                                e.preventDefault(); this.restoreVersionConfirmation(item.file_name)
                              }} >
                              <span>
                                <i className="fa fa-window-restore text-red mr-3" /> Restore this version
                            </span>
                            </DropdownItem>
                            <DropdownItem >
                              <span>
                                <i className="fas fa-copy mr-3 mr-3" /> Make a copy
                          </span>
                            </DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </Col>
                    </Row>
                    <Row >
                      <Col className="project-col version-name" xs="9">
                        <Badge color="" className="badge-dot">
                          <i className={this.state.selectedVersionName === item.file_name ? "bg-success" : "bg-darkgray"} />
                          {item.metadata.hasOwnProperty('created_by') ? item.metadata.created_by : "" }
                        </Badge>
                      </Col>
                    </Row> 
                </li>
        ))
  }
  <li className="list-group-item view-latest borderless">
  {this.state.listversioning !== null && this.state.listversioning !== undefined && this.state.listversioning.length < 1 &&
    <span className="text-center font-weight-bold"> No Versioning Found</span>
  }
  </li>
  </ul>

<Modal
                          centered
                          className="rename-modal"
                          isOpen={this.state.showSaveModal}
                          toggle={this.toggleSaveModal}
                          backdrop="static"
                          returnFocusAfterClose={false}>
                          <ModalHeader toggle={this.toggleSaveModal}>Comments to Restore</ModalHeader>
                          <ModalBody>
                            <Input
                              type="textarea"
                              placeholder="Comments to Save"
                              name="commentstosave"
                              className="inputRename"
                              maxLength="150"
                              value={this.state.savecomments}
                              onChange={this.saveCommentschange}
                            />
                            <Row>
                              <Col sm={12} lg={12} xl={12}>
                              <span className="notepopHint">Note: </span><span className="notetxt"> <code>Comments should be more than 4 letters and less than 100 letters</code></span>
                              </Col>
                              </Row>
                              <Row>
                            <Col sm={12} lg={12} xl={12}>
                                {this.state.showSavebutton === true &&
                                  <Button
                                    size="sm"
                                    color="primary"
                                    className="storage-folder-btn renameBtn"
                                    onClick={ e => this.restoreVersion(this.state.savecomments)}
                                  >
                                    Restore 
                                </Button>
                                }
                              </Col>
                          
                            </Row>

                          </ModalBody>
                        </Modal>
                     
          <Modal centered className="rename-modal" isOpen={this.state.showVersionInfo} toggle={e => { this.toggleVersionInfo() }} backdrop="static" returnFocusAfterClose={false}>
            <ModalHeader toggle={e => { this.toggleVersionInfo() }}>Versioning Details</ModalHeader>
            <ModalBody>
              <Row>
                <Col md="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg="12" sm="12">
                          <Card className="card-stats">
                            <CardBody>
                            <Table id={uuidv4()}>
            <tbody className="bordernone">
            {(this.state.currentVersion !== "" &&  this.state.currentVersion !== null && this.state.currentVersion !== undefined) ? <tr>
                <td className="headerwidth"><b className="info-title"> Version : </b></td>
                <td><b><code> {convertTextToTitleCase(this.state.currentVersion) === "Original" ? "Original" : ""} 
                  {convertTextToTitleCase(this.state.currentVersion)  !== "Original" ? <b><code>{moment.utc(this.state.currentVersion).local().format('MMM DD YYYY', 'h:mm:ss a')} {moment.utc(this.state.currentVersion).local().format('h:mm A')} </code></b> : ""}
                   </code></b></td>
                </tr> : ""}
                {(this.state.currentcreatedBy !== "" &&  this.state.currentcreatedBy !== null && this.state.currentcreatedBy !== undefined) ? <tr>
                <td className="headerwidth"><b className="info-title"> Created By : </b></td>
                <td><b><code>{this.state.currentcreatedBy} </code></b></td>
              </tr> : ""}
              {(this.state.currentComments !== "" &&  this.state.currentComments !== null && this.state.currentComments !== undefined) ? <tr><td className="headerwidth"> <b className="info-title"> Comments:  </b></td>
              <td><b><code>{this.state.currentComments} </code></b></td>
                </tr> : ""}
                {(this.state.restoredat !== "" &&  this.state.restoredat !== null && this.state.restoredat !== undefined) ? <tr>
                <td className="headerwidth"><b className="info-title"> Restored At : </b></td>
                <td><b><code>{moment.utc(this.state.restoredat).local().format('MMM DD YYYY', 'h:mm:ss a')} {moment.utc(this.state.restoredat).local().format('h:mm A')}
            </code></b></td>
                </tr> : ""}
                {(this.state.restoredby !== "" &&  this.state.restoredby !== null && this.state.restoredby !== undefined) ? <tr>
                <td className="headerwidth"><b className="info-title"> Restored By : </b></td>
                <td><b><code>{this.state.restoredby} </code></b></td>
              </tr> : ""}

              </tbody>
              </Table>


                            </CardBody>
                          </Card>
                        </Col>
                      </Row>


                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Scrollbars>
      </div>
    )
  }
}
export default Versioning;

